import crypto from 'crypto'     // 加密
import axios from 'axios'
const config ={
    app_id: 'A6045900985876',
    app_key: '561084B2-4AFB-9279-7F7F-0B555DF7658B',
    api:'https://d.apicloud.com/mcm/api',
}

const now = Date.now(); //当前时间
const sha1 = crypto.createHash('sha1');

sha1.update(config.app_id + "UZ" + config.app_key + "UZ" + now);
// 添加请求头  
axios.defaults.headers["X-APICloud-AppId"] = config.app_id;
axios.defaults.headers["X-APICloud-AppKey"] = sha1.digest('hex') + "." + now;


export const headers = axios.defaults.headers;

/**
 * @description 实例化apicloud 请求对象。
 * @param {String} {url} 请求地址
 * @param {String} {api} 具体方法
 * @param {String} {data} 传入参数
 * @param {String} {method} 请求方式
 */
const api_request = ({url,data,method,filters})=>{
    let opt = {
        baseURL:config.api,
        url,
        method,
        data,
    }  
    if (url.indexOf('user')==-1){
        opt.params={
            filter:{
                limit:5000,
                where:{
                    ...filters
                }
            }
        };
        opt.paramsSerializer=(params)=> {
            console.log(params);
            let a = `filter=${(JSON.stringify(params.filter))}`;
            console.log(a);
            return a;
        }
    }
        
    return axios(opt);
}

export const Append_Header=({key,value},url)=>{
    axios.defaults.headers[key]= value;
    console.log(axios.defaults.headers);
    return api_request({url,method:'post'});
}

export const Get=(url)=>{
    return api_request({url});
}

export const Count=(url)=>{
    return api_request({url});
}

export const Exists=(url,id)=>{
    return api_request({url:`${url}/${id}/exists`});
}

export const GetByID=(url,id)=>{
    return api_request({url:`${url}/${id}`});
}

export const Where=({url,filters})=>{
    return api_request({url,filters});
}


export const Post=(url,data)=>{
    return api_request({url,data,method:'post'});
}

export const Put=(url,id,data)=>{
    return api_request({url:`${url}/${id}`,data,method:'put'});
}

export const Delete=(url,id)=>{
    return api_request({url:`${url}/${id}`,method:'delete'});
}


export const GetRelations=(url,id,relation)=>{
    return api_request({url:`${url}/${id}/${relation}`});
}

export const PostRelations=(url,id,relation,data)=>{
    return api_request({url:`${url}/${id}/${relation}`,method:'post',data});
}




